export const DefaultOptionalItems = [
  {
    text: '',
    checked: false,
    key: 'whatson',
  },
];

export const DefaultTCItems = [
  {
    text: 'Visit our website on www.fairfieldcity.nsw.gov.au/facilitybooking  to read and accept the terms and conditions and would like to proceed with the booking.',
    checked: false,
  },
];

export const DefaultTCcollection = [];

export const GeneralTerms = {
  tcs: {
    // 'I hereby to follow the COVID safty plan, policy and procedures.',
    fchq: [
      'The Hirer must be a responsible person and at least eighteen (18) years or older. The Hirer will be held liable to the Council for the cost of the repair of any damage or breakage to any part of the building, premises, fitting or furniture, appliances or apparatus during the term of the hire. The Hirer must remain in attendance and is responsible for safety of guests and supervising all activities during the hire period.',
      'Council reserves the right to refuse any booking or cancel a booking by giving as much notice as is practicable, due to emergency conditions such as urgently needed repairs, holding of Federal, State or Local Government Elections or other reasons deemed acceptable by Council.',
      'Neither Council, nor any of its officers or stewards shall in any way be liable for any loss or damage suffered by the Hirer, or any firm or corporation supplying any article or service to the Hirer, or otherwise in consequence of the exercise of its right.'
    ],
    futsal: [
      'I am over the age of 18.',
      'There are no credits or refunds for rain days.',
      'Your code will not allow access to the pin pad before your allocated times.',
      'I will ensure that I leave the space in a neat and tidy condition.',
      'Tennis and Futsal courts have a no smoking and alcohol policy on the premises.',
      'I understand that any misuse of the venue could result in action for damages against me.',
      'I have read, understood and will abide by the Conditions/terms of Use.',
    ],
    whitlam: [
      'I am over the age of 18.',
      'There are no credits or refunds for rain days.',
      'Your code will not allow access to the pin pad before your allocated times.',
      'I will ensure that I leave the space in a neat and tidy condition.',
      'Tennis and Futsal courts have a no smoking and alcohol policy on the premises.',
      'I understand that any misuse of the venue could result in action for damages against me.',
      'I have read, understood and will abide by the Conditions/terms of Use.',
    ],
    tennis: [
      'I am over the age of 18.',
      'There are no credits or refunds for rain days.',
      'Your code will not allow access to the pin pad before your allocated times.',
      'I will ensure that I leave the space in a neat and tidy condition.',
      'Tennis and Futsal courts have a no smoking and alcohol policy on the premises.',
      'I understand that any misuse of the venue could result in action for damages against me.',
      'I have read, understood and will abide by the Conditions/terms of Use.',
    ]
    // 'I will notify staff if I leave prior to end of booking time(**applied to indoor bookings only ).',
  },
  Compulsory: true,
};
